/**
 * Overview Query Keys
 *
 * Centralized query key factory for the matter overview cache (the
 * dashboard / summary panel hydrated by `useMatterOverview`). The root
 * key intentionally remains `['overview', matterId]` to match the
 * existing on-the-wire cache shape used by readers and invalidators
 * across the codebase — changing it would silently miss live caches.
 */

/**
 * Overview query key factory
 *
 * @example
 * ```typescript
 * useQuery({ queryKey: overviewKeys.forMatter(matterId), queryFn: ... })
 * queryClient.invalidateQueries({ queryKey: overviewKeys.forMatter(matterId) })
 * ```
 */
export const overviewKeys = {
  /**
   * Root key for all overview queries
   */
  all: ['overview'] as const,

  /**
   * Matter overview for a specific matter
   * @param matterId - The matter ID
   */
  forMatter: (matterId: number) => [...overviewKeys.all, matterId] as const
} as const;
